import { render, staticRenderFns } from "./demo-bind-device.vue?vue&type=template&id=36d51bed&scoped=true&"
import script from "./demo-bind-device.vue?vue&type=script&lang=js&"
export * from "./demo-bind-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d51bed",
  null
  
)

export default component.exports